import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { MdAnalytics } from "react-icons/md";
import { BiSolidCategoryAlt } from "react-icons/bi";
import { RiCoupon2Fill } from "react-icons/ri";
import { TbTruckDelivery } from "react-icons/tb";
import { FaShop, FaSackDollar, FaCreditCard, FaNetworkWired, FaEnvelope, FaUsers, FaBoxesStacked, FaGlobe } from "react-icons/fa6";
import { FaUserCircle, FaMoneyBill } from "react-icons/fa";
import { BsFileEarmarkRuledFill, BsInfoSquareFill } from "react-icons/bs";
import { MdOutlineChat } from "react-icons/md";
import { HiOutlineLogout, HiUsers } from "react-icons/hi";
import { GrServices } from "react-icons/gr";
import { AuthContext } from '../../utils/AuthContext';

function AdminHeader() {
  const { isAdminLogin, admin, refreshChatUnreadCount, adminLogout } = useContext(AuthContext);

  React.useEffect(() => {
    if (isAdminLogin && admin) {
      refreshChatUnreadCount({ isAdmin: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminLogin, admin]);

  const hasAccess = (page) => {
    if (admin?.role === 'Super Admin') return true;
    if (admin?.role === 'Admin') return page !== 'Employees';
    if (admin?.role === 'Moderator') return admin?.access[page] !== undefined;
    return false;
  };

  const pages = [
    { path: 'dashboard', icon: <MdAnalytics className='icon' />, label: 'Dashboard' },
    { path: 'categories', icon: <BiSolidCategoryAlt className='icon' />, label: 'Categories' },
    { path: 'coupons', icon: <RiCoupon2Fill className='icon' />, label: 'Coupons' },
    { path: 'orders', icon: <TbTruckDelivery className='icon' />, label: 'Orders' },
    { path: 'sellers', icon: <FaShop className='icon' />, label: 'Sellers' },
    { path: 'buyers', icon: <FaUserCircle className='icon' />, label: 'Buyers' },
    { path: 'products', icon: <FaBoxesStacked className='icon' />, label: 'Products' },
    { path: 'services', icon: <GrServices className='icon' />, label: 'Services' },
    { path: 'revenue', icon: <FaSackDollar className='icon' />, label: 'Revenue' },
    { path: 'payments', icon: <FaCreditCard className='icon' />, label: 'Payments' },
    { path: 'restricted-countries', icon: <FaGlobe className='icon' />, label: 'Countries' },
    { path: 'social', icon: <FaNetworkWired className='icon' />, label: 'Social Links' },
    { path: 'fee', icon: <FaMoneyBill className='icon' />, label: 'Fee' },
    { path: 'terms', icon: <BsFileEarmarkRuledFill className='icon' />, label: 'Terms & Conditions' },
    { path: 'disputes', icon: <HiUsers className='icon' />, label: 'Disputes' },
    { path: 'chats', icon: <MdOutlineChat className='icon' />, label: 'Chats' },
    { path: 'faq', icon: <BsInfoSquareFill className='icon' />, label: 'Information Center' },
    { path: 'emails', icon: <FaEnvelope className='icon' />, label: 'Email Campaigns' },
    { path: 'employees', icon: <FaUsers className='icon' />, label: 'Employees' },
  ];

  return (
    <div className='adminHeaderDiv'>
      <section className="section">
        <div className="adminHeaderContent">

          <div className="faithzyLogoDiv">
            <img src="/assets/images/logo.svg" alt="Buylio Logo" className='faithzyLogo' />
          </div>

          <div className="horizontalLine"></div>

          <ul className="mainMenu">
            {pages.map((page, index) => (
              hasAccess(page.label) && (
                <li key={index}>
                  <NavLink to={`/blo-admin/${page.path}`} className={(v) => `${v.isActive ? "activeLi" : ""}`}>
                    {page.icon}
                    {page.label}
                  </NavLink>
                </li>
              )
            ))}
            <li>
              <NavLink className="adminLogoutBtn" onClick={adminLogout}><HiOutlineLogout /> Logout</NavLink>
            </li>
          </ul>

        </div>
      </section>
    </div>
  );
}

export default AdminHeader;